// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RxntCredentialRequest } from './rxnt-credential-request';

/** See com.rev360.pms.api.controller.header.EmployeeExternalCredentialsRequest */
/* istanbul ignore next */
@GandalfModel
export class EmployeeExternalCredentialsRequest extends GandalfModelBase {

	@GandalfSubRequestLabel('RXNT Credentials')
	@GandalfValidator({ notNull: { message: 'RXNT credential is required.' } })
	@GandalfProperty({ designType: RxntCredentialRequest, isRequired: true })
	rxntCredential!: RxntCredentialRequest;

}
